import React, { memo } from "react";
import { Input, Dropdown } from "semantic-ui-react";
import DatePicker from "react-datepicker";
import { configOptions } from "env.config";

export const TextFilter = memo(({ placeholder, onChangeFilter, onKeyDown }) => {
  return (
    <div style={{ float: "left", paddingRight: "1rem" }}>
      <Input
        placeholder={placeholder}
        style={{ maxWidth: "24em" }}
        onKeyDown={onKeyDown}
        onChange={onChangeFilter}
      />
    </div>
  );
});

export const TableFilter = memo(
  ({ datePickerInfo, onChangeTextFilter, onChangeDateFilter, onSearch }) => (
    <>
      <TextFilter
        placeholder='User'
        onKeyDown={onSearch}
        onChangeFilter={onChangeTextFilter.bind(null, "user")}
      />
      <TextFilter
        placeholder='Operator'
        onKeyDown={onSearch}
        onChangeFilter={onChangeTextFilter.bind(null, "operator")}
      />
        <Dropdown
          search
          clearable
          placeholder='Action'
          selection
          onKeyDown={onSearch}
          options={configOptions.actionFilter}
          onChange={onChangeTextFilter.bind(null, "action")}
          style={{width: "222px", marginRight: "14px"}}
        />
      <TextFilter placeholder='Data' onKeyDown={onSearch} onChangeFilter={onChangeTextFilter.bind(null, "data")} />
      <DatePicker
        showTimeSelect
        isClearable
        dateFormat='yyyy/MM/dd HH:mm'
        className='audit-date'
        selected={datePickerInfo.start}
        placeholderText='Start Date'
        onKeyDown={onSearch}
        onChange={onChangeDateFilter.bind(null, "start")}
      />
      <DatePicker
        showTimeSelect
        isClearable
        dateFormat='yyyy/MM/dd HH:mm'
        className='audit-date'
        selected={datePickerInfo.end}
        placeholderText='End Date'
        onKeyDown={onSearch}
        onChange={onChangeDateFilter.bind(null, "end")}
      />
    </>
  )
);
